import React, { useState } from 'react'

import { Heading1,Paragraph1 } from "../../../components/Ui";
import bannerBg from '../../../assets/img/landing-page/landing-page-bg.png';
import EmailReport from './components/EmailReport';
import assets from './components/images'; 
import "../../../assets/styles/section.module.css"
import SkeletonLoader from './components/SkeletonLoader';


export default function Emailverify() {
  let Divein = [
    { img: assets.images.Img1, title: "Syntax Check", des: "Identify and eliminate errors with a thorough syntax examination, maintaining the integrity of your contact list." },
    { img: assets.images.Img2, title: "Domain Verification", des: "Ensure emails are linked to valid domains, enhancing the reliability of your communication channels." },
    { img: assets.images.Img3, title: "Anti-Spam Checks", des: "Boost deliverability by avoiding spam traps, safeguarding your emails from being flagged as spam." },
  ]

  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [resultShown, setResultShown] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setResultShown(false);

    // Simulate an API call
    setTimeout(() => {
      setLoading(false);
      setResultShown(true);
    }, 2000); // Mock loading time
  };

  const data = {
    full_name: "John Doe",
    email: "john.doe@example.com",
    score: 85,
    gender: "Male",
    state: "undeliverable",
    reason: "Valid",
    domain: "example.com",
    free: true,
    role: false,
    disposable: false,
    accept_all: false,
    tag: "Verified",
    mailbox_full: false,
    no_reply: false,
    smtp_provider: "Google",
    mx_record: "mail.example.com",
  };
  

  return (
    <>
  
     {/* Hero Section */}
     <section
        style={{
          backgroundImage: `url(${bannerBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover",
          padding: "2rem 0 6rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={assets.images.EmailVerifyimg}
          alt="Email Verify"
          style={{ 
                width: "20%",
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                marginTop: "50px", 
           }}
        />
        <div style={{ textAlign: "center" }}>
          <Heading1 heading1="Email Verifier" />
        </div>
        <div style={{ textAlign: "center" }}>
          <Paragraph1 para1="Ensure Deliverability, Boost Confidence with Email Verification Excellence" />
        </div>
      </section>

      {/* Search Section */}
      <section style={{ padding: "0 1rem", marginTop: "-80px" }}>
        <div
          style={{
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: "2rem",
            margin: "2rem auto",
            maxWidth: "60%",
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
          }}
        >
          <h3
            style={{
              fontWeight: "600",
              fontSize: "1.125rem",
              textAlign: "center",
              color: "#000",
            }}
          >
            Elevate Your Inbox Credibility Instantly!
          </h3>
          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              height: "2.5rem",
              borderRadius: "8px",
            }}
          >
            <input
              type="search"
              value={search}
              placeholder="bill@microsofts.com"
              onChange={(e) => setSearch(e.target.value)} // Update the state on user input
              style={{
                flex: "1",
                padding: "0.5rem",
                border: "none",
                outline: "none",
                backgroundColor: "#F5F5F5",
                fontSize: "1rem",
              }}
            />
            <button
              style={{
                width: "12rem",
                height: "2.5rem",
                background: "linear-gradient(to right, #56F444, #55EE44, #48FA8A)",
                border: "none",
                borderRadius: "8px",
                color: "#000",
                fontSize: "1rem",
                cursor: "pointer",
              }}
            >
              Find Email
            </button>
          </form>

          {loading ? (
                <SkeletonLoader />
            ) : resultShown ? (
                <EmailReport data={data} />
            ) : (
                <></>
            )}
          {/* Attributes and Mail Server Sections */}
          
        </div>
      </section>
      {/* Dive In */}
      <section style={{ backgroundColor: '#F5F5F5', marginTop: '2.5rem' }}>
  <div style={{ padding: '2.5rem 0', maxWidth: '1200px', margin: '0 auto' }}>
    <div
      style={{
        textAlign: 'center',
        margin: '0 auto',
        lineHeight: '1.5',
        maxWidth: '50%',
      }}
    >
      <Heading1 heading1="Dive In: Features That Redefine Excellence" />
    </div>
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '0.75rem',
        marginTop: '1rem',
      }}
    >
      {Divein.map((val, id) => (
        <div
          key={id}
          style={{
            textAlign: 'center',
            marginTop: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75rem',
            padding: '1.25rem',
          }}
        >
          <img
            style={{
              margin: '0 auto',
              height: '4rem',
              width: '4rem',
            }}
            src={val.img}
            alt="my-img"
          />
          <h4
            style={{
              fontSize: '1.25rem',
              fontWeight: '500',
            }}
          >
            {val.title}
          </h4>
          <p
            style={{
              fontSize: '0.875rem',
              color: '#6B7280',
            }}
          >
            {val.des}
          </p>
        </div>
      ))}
    </div>
  </div>
        </section>



        <section
        style={{
            maxWidth: '1200px',
            margin: '2.5rem auto', // my-10 and md:my-16 equivalent
        }}
        >
        <div
            style={{
            background: 'linear-gradient(to right, #56F444, #55EE44, #48FA8A)',
            padding: '2.5rem 1rem',
            borderRadius: '0.5rem',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            textAlign: 'center',
            }}
        >
            <h1
            style={{
                fontSize: '1.875rem', // Large font size
                fontWeight: '700',
                lineHeight: '1.5',
                marginBottom: '1rem',
                color: '#000', // Text color black
            }}
            >
            Empower Your Future: Take Charge Today!
            </h1>
            <p
            style={{
                fontSize: '1rem',
                marginBottom: '1.5rem',
                color: '#4B5563', // Text color gray
            }}
            >
            Seize the moment and propel your journey to success with our exclusive
            Call-to-Action! Embrace a future of unparalleled possibilities as you take
            the next step.
            </p>
            <button
            style={{
                padding: '0.75rem 2rem',
                fontSize: '1rem',
                fontWeight: '600',
                backgroundColor: '#FFF',
                color: '#48FA8A',
                border: 'none',
                borderRadius: '0.375rem',
                cursor: 'pointer',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            }}
            >
            Start for Free
            </button>
        </div>
        </section>

        <section
  style={{
    backgroundColor: '#F5F5F5',
    padding: '2.5rem 0',
  }}
>
  <div
    style={{
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'row',
      gap: '1.5rem',
      alignItems: 'center',
    }}
  >
    {/* Left Section (Image with Button) */}
    <div
      style={{
        flex: 1,
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <a
        href="/"
        style={{
          position: 'absolute',
          top: '1.5rem',
          right: '1.5rem',
          backgroundColor: 'black',
          color: 'white',
          borderRadius: '0.375rem',
          padding: '0.5rem 1.25rem',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          fontSize: '0.875rem',
          fontWeight: '600',
          textDecoration: 'none',
        }}
      >
        Detailed Reporting
      </a>
      <img
        src={assets.images.Unleash}
        alt="Detailed Reporting"
        style={{
          width: '100%',
          height: 'auto',
          borderRadius: '0.375rem',
        }}
      />
    </div>

    {/* Right Section (Heading, Paragraph, List, Button) */}
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '1.5rem',
      }}
    >
      <h2
        style={{
          fontSize: '2rem',
          fontWeight: '700',
          marginBottom: '0.5rem',
        }}
      >
        Unleash Potential: Click For Success Now!
      </h2>
      <p
        style={{
          fontSize: '1rem',
          lineHeight: '1.5',
          color: '#6b7280',
        }}
      >
        Don't Miss Out—Click Now To Experience The Transformation Your Business
        Deserves.
      </p>
      <ul
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
          gap: '1rem',
          listStyleType: 'none',
          padding: 0,
        }}
      >
        <li
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '1rem',
            color: '#374151',
          }}
        >
          <assets.icons.FaCheck
            style={{
              color: '#16A34A',
              marginRight: '0.5rem',
            }}
          />
          Custom Integrations
        </li>
        <li
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '1rem',
            color: '#374151',
          }}
        >
          <assets.icons.FaCheck
            style={{
              color: '#16A34A',
              marginRight: '0.5rem',
            }}
          />
          API Access
        </li>
        <li
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '1rem',
            color: '#374151',
          }}
        >
          <assets.icons.FaCheck
            style={{
              color: '#16A34A',
              marginRight: '0.5rem',
            }}
          />
          Detailed Reporting
        </li>
        <li
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '1rem',
            color: '#374151',
          }}
        >
          <assets.icons.FaCheck
            style={{
              color: '#16A34A',
              marginRight: '0.5rem',
            }}
          />
          24/7 Support
        </li>
      </ul>
      <a
        href="/"
        style={{
          display: 'inline-block',
          backgroundColor: '#16A34A',
          color: 'white',
          padding: '0.75rem 1.5rem',
          borderRadius: '0.375rem',
          fontSize: '1rem',
          fontWeight: '600',
          textDecoration: 'none',
          textAlign: 'center',
          marginTop: '1rem',
        }}
      >
        Start for Free
      </a>
    </div>
  </div>
</section>


      {/* Ignite Growth */}
      <section
  style={{
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '2rem 1rem',
    backgroundColor: '#030621', // Dark background
    borderRadius: '0.5rem', // Rounded corners
    color: 'white', // White text
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr', // Two columns
    gap: '1.5rem',
    alignItems: 'center', // Align items vertically in the center
    marginTop: "50px", 

  }}
>
  {/* Left Column (Text Content) */}
  <div
    style={{
      padding: '2rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      justifyContent: 'center',
    }}
  >
    <h2
      style={{
        fontSize: '2rem',
        fontWeight: '700',
        marginBottom: '0.5rem',
      }}
    >
      Ignite Growth: Seize Your Success Moment!
    </h2>
    <h3
      style={{
        fontSize: '1.125rem',
        fontWeight: '600',
      }}
    >
      Your Success Is Just One Click Away!
    </h3>
    <p
      style={{
        fontSize: '1rem',
        lineHeight: '1.5',
        color: '#d1d5db', // Light gray text
      }}
    >
      Your Success Is Just One Click Away! Grab The Opportunity To Ignite Growth
      And Elevate Your Endeavors. Act Now And Witness The Transformative Power
      Of Taking That Decisive Step.
    </p>
  </div>

  {/* Right Column (Image) */}
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <img
      src={assets.images.Ignitegrowth}
      alt="Ignite Growth"
      style={{
        width: '100%',
        height: 'auto',
        borderRadius: '0.375rem',
      }}
    />
  </div>
</section>

      {/* Slider logos here */}
   
      </>

  )
}
